import type {DesignSystemVersion} from './types';

/** Switch active theme tokens — must match a file in designSystem/definitions/ */
// export const ACTIVE_DESIGN_SYSTEM_VERSION: DesignSystemVersion = 'monochrome';
export const ACTIVE_DESIGN_SYSTEM_VERSION: DesignSystemVersion = '20260616';
// export const ACTIVE_DESIGN_SYSTEM_VERSION: DesignSystemVersion = '20260615';
